import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { identity } from 'ramda';

import { Video, Container, Image } from './lazyLoadVideo.styles';
import { renderWhenNotNil } from '../../utils/rendering';

export class LazyLoadVideo extends PureComponent {
  static propTypes = {
    autoPlay: PropTypes.bool,
    className: PropTypes.any,
    controls: PropTypes.bool,
    file: PropTypes.object,
    loop: PropTypes.bool,
    muted: PropTypes.bool,
    playsInline: PropTypes.bool,
    playerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    poster: PropTypes.object,
    posterProps: PropTypes.object,
    preload: PropTypes.string,
    placeholderStyle: PropTypes.any,
    onEnded: PropTypes.func,
  };

  static defaultProps = {
    poster: {},
    file: {},
    onEnded: identity,
    playerRef: identity,
  };

  state = {
    loaded: false,
  };

  handleCanPlay = () => this.setState({ loaded: true });

  handleEnded = () => this.props.onEnded();

  renderVideo = renderWhenNotNil(() => (
    <Video
      ref={this.props.playerRef}
      visible={this.state.loaded}
      onCanPlay={this.handleCanPlay}
      onEnded={this.handleEnded}
      autoPlay={this.props.autoPlay}
      muted={this.props.muted}
      loop={this.props.loop}
      playsInline={this.props.playsInline}
      controls={this.props.controls}
      preload={this.props.preload}
    >
      <source src={this.props.file.url} />
    </Video>
  ));

  render() {
    return (
      <Container className={this.props.className}>
        <Image placeholderStyle={this.props.placeholderStyle} file={this.props.poster} {...this.props.posterProps} />
        <LazyLoad offset={300} once scroll resize>
          {this.renderVideo(this.props.file.url)}
        </LazyLoad>
      </Container>
    );
  }
}
